<template>
  <div class="my-5 text-size-14">
    <AppButton
      :href="externalLink.contact"
      size="small"
      block
      rounded
      class="mb-3"
    >
      お問い合わせフォーム
    </AppButton>
  </div>
</template>

<script lang="ts">
import { Vue, Component } from "vue-facing-decorator";
import AppButton from "@/components/atoms/button/AppButton.vue";

@Component({
  components: {
    AppButton
  }
})
export default class SmsAuthWithPhoneSwitchContactForm extends Vue {
  externalLink = {
    contact: process.env.VUE_APP_URL_CONTACT,
    contactPhoneNumber: `tel:${process.env.VUE_APP_CONTACT_PHONE_NUMBER}`
  };
}
</script>
